import React from "react";
import UnifiedDocument from "./UnifiedDocument";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const SalesOrder = () => {
  return <UnifiedDocument documentType={DOCUMENT_TYPES.SALES_ORDER} />;
};

export default SalesOrder;
